import { forwardRef } from 'react'
import classNames from 'classnames'

import styles from './styles/Input.css'
import Paragraph from '../typography/Paragraph'

const Input = forwardRef(({ className, label = '', id = '', required = false, type = '', placeholder, ...rest }, ref) => {
  const setId = id || label.toLowerCase()

  if (label) {
    return (
      <label htmlFor={setId}>
        <Paragraph type='small' className={styles.label}>
          {label}{required && <span className={styles.required}>*</span>}
        </Paragraph>
        <input
          ref={ref}
          className={classNames(styles.input, className)}
          type={type || 'text'}
          id={setId}
          name={setId}
          required={required}
          placeholder={placeholder || required ? `${label} (required)` : label}
          {...rest}
        />
      </label>
    )
  }

  return (
    <input
      className={classNames(styles.input, className)}
      required={required}
      type={type || 'text'}
      placeholder={placeholder}
      {...rest}
    />
  )
})

export default Input
